interface ShouldShowCartDetailsParams {
  isStudentBulkUnitAssignment: boolean;
  floorPlanId?: number | string | null;
  leaseTerm?: unknown;
  unit?: unknown;
  waitlistFloorplanIds?: readonly unknown[] | null;
  quoteLeaseTermId?: number | string | null;
  quoteUnitSpaceId?: number | string | null;
}

export function shouldShowCartDetails({
  isStudentBulkUnitAssignment,
  floorPlanId,
  leaseTerm,
  unit,
  waitlistFloorplanIds,
  quoteLeaseTermId,
  quoteUnitSpaceId,
}: ShouldShowCartDetailsParams): boolean {
  if (isStudentBulkUnitAssignment) {
    return Boolean(floorPlanId && leaseTerm);
  }

  if (unit && leaseTerm) {
    return Boolean(unit && leaseTerm);
  }

  if ((waitlistFloorplanIds?.length ?? 0) > 0) {
    return Boolean(waitlistFloorplanIds?.length);
  }

  return Boolean(quoteLeaseTermId && quoteUnitSpaceId);
}
